<template>
    <div class="help">
        <q-list>
            <q-item class="head">
                <q-item-side left :icon=" $route.name === 'Dashboard' ? 'dashboard' : mapIcon(help.icon)" />
                <q-item-main>{{ $route.name === 'Dashboard' ? 'Dashboard' : getString(help.label) }}</q-item-main>
                <q-item-side
                    class="close-help"
                    right
                    icon="close"
                    @click.native="$root.$emit('closeRightDrawer')"
                />
            </q-item>
            <q-item class="to-module" v-ripple link @click.native="toModule">
                <q-item-main>{{
                    $store.state.stringsStore.strings.sideHelp.more
                }}</q-item-main
                ><q-icon name="keyboard_arrow_right" />
            </q-item>
        </q-list>
        <div class="help-content" v-if="$route.name === 'Dashboard' || nothingFound">
          <div class="help-content__page no-padding">
            <!-- <p v-html="$store.state.stringsStore.strings.sideHelp.notAvailable"></p> -->
            <template v-for="(category, index) in $store.state.helpStore.help">
              <div :key="index">
                <div class="row">
                  <div class="full-width">
                    <p class="card-title capitalize q-ma-md" v-if="index === 'general'">
                      Help overview
                    </p>
                    <div class="card-block no-padding scroll no-border-radius">
                      <template v-for="(module, i) in category">
                        <q-list :key="i" class="custom-q-list accordion">

                          <!-- Help for genaral topics -->
                          <div v-if="index === 'general'">
                            <q-collapsible group="collapsibles" :duration="50" :label="module.title">
                              <div class="row">
                                <div class="col-12 q-pa-md q-pb-md">
                                  <p v-html="module.intro"></p>
                                  <router-link @click.native="toDetail(module.location)" class="text-weight-bold read-link" to="" icon="mdi mdi-chevron-right icon">
                                    {{ $store.state.stringsStore.strings.read }} <q-icon size="large" name="mdi-chevron-right"/></router-link>
                                </div>
                              </div>
                            </q-collapsible>
                          </div>
                        </q-list>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="help-content q-ma-md" v-else>
            <template v-for="(page, index) in help.pages">
                <div class="help-content__page" :key="index">
                    <p
                        v-if="page.title != ''"
                        class="help-content__page__title text-weight-bold"
                    >
                        {{ page.title }}
                    </p>
                    <p v-html="page.intro"></p>
                    <router-link v-if="page.location" @click.native="toDetail(page.location)" class="text-weight-bold read-link q-mb-md" to="" icon="mdi mdi-chevron-right icon">
                    {{ $store.state.stringsStore.strings.read }} <q-icon size="large" name="mdi-chevron-right"/></router-link>
                </div>
            </template>
          </div>
        </div>
</template>

<script>

import _get from 'lodash.get';

export default {
  name: 'HelpDrawer',
  created() {
    // Listen to setHelp event which is emitted by opening the right drawer
    this.$root.$on('setHelp', this.setHelp);
  },
  data() {
    return {
      help: {},
      nothingFound: false,
      icons: {
        dashboard: 'dashboard',
        usergroups: 'people',
        developer: 'code',
        library: 'library_books',
        blog: 'art_track',
        news: 'import_contacts',
        press: 'camera',
        master: 'select_all',
        error: 'error_outline',
        faq: 'question_answer',
        page: 'web',
        hub: 'mdi-hexagon-multiple',
        product: 'devices_other',
        branch: 'mdi-source-branch',
        reference: 'domain',
        navigation: 'mdi-file-tree',
        content: 'toc',
        service: 'mdi-lifebuoy',
        event: 'date_range',
        popup: 'announcement',
        // service: 'support_agent',
      },
    };
  },
  methods: {
    // Link to parentModule (/help)
    toModule() {
      this.$router.push('/help');
    },
    mapIcon(icon) {
      return this.icons[icon] ? this.icons[icon] : this.icons.error;
    },
    getString(path) {
      return _get(this.$store.state.stringsStore.strings, path);
    },
    toDetail(location) {
      /**
       * Because the API gives back a location on the dev-env we need to retrieve the last
       * value after the slash of this location and use it for our own routing
      */
      const last = location.split('/');
      this.$router.push(`/help/${last[last.length - 3]}/${last[last.length - 2]}`);
    },
    setHelp() {
      const modules = Object.values(this.$store.state.helpStore.help.modules).map(m => m.label);

      if (modules.includes(this.$route.meta.help)) {
        for (const key in this.$store.state.helpStore.help.modules) {
          if (this.$store.state.helpStore.help.modules[key].label === this.$route.meta.help) {
            this.help = this.$store.state.helpStore.help.modules[key];
          }
        }
      } else {
        this.nothingFound = true;
        this.help = {
          label: 'module.help.filter.noResults.text',
          icon: 'error_outline',
          pages: [{
            intro: this.$store.state.stringsStore.strings.sideHelp.notAvailable,
          }],
        };
      }
    },
  },
};
</script>

<style lang="stylus">
    @import '~variables';
    @import '../styles/components/help';
.no-padding
  padding-bottom 0
  margin-bottom 0
.no-border-radius
  border-radius 0
</style>
